export enum CustomComponentTypes {
    None = 0,
    MedicationHistory = 1 << 0,  // 1
    ConsultationHistory = 1 << 1, // 2
    EpisodeNotes = 1 << 2, // 4
    ConsultationHistoryV2 = 1 << 3, // 8
}